import { render, staticRenderFns } from "./lotPriceList.vue?vue&type=template&id=5c4e1145&scoped=true"
import script from "./lotPriceList.vue?vue&type=script&lang=js"
export * from "./lotPriceList.vue?vue&type=script&lang=js"
import style0 from "./lotPriceList.vue?vue&type=style&index=0&id=5c4e1145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e1145",
  null
  
)

export default component.exports